import { apiConfig } from "@pjs/asset-block";

apiConfig.validateEmbedRequest = () => `${window.config.getApiBaseUrl()}Builder/ValidateEmbedRequest`;
